var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16528_1192)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00098 5.88898C2.00098 2.97298 2.03198 2.00098 5.88898 2.00098C9.74598 2.00098 9.77698 2.97298 9.77698 5.88898C9.77698 8.80498 9.78898 9.77698 5.88898 9.77698C1.98898 9.77698 2.00098 8.80098 2.00098 5.88898Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2212 5.88898C14.2212 2.97298 14.2522 2.00098 18.1092 2.00098C21.9662 2.00098 21.9972 2.97298 21.9972 5.88898C21.9972 8.80498 22.0092 9.77698 18.1092 9.77698C14.2092 9.77698 14.2212 8.80098 14.2212 5.88898Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00098 18.109C2.00098 15.193 2.03198 14.221 5.88898 14.221C9.74598 14.221 9.77698 15.193 9.77698 18.109C9.77698 21.025 9.78898 21.997 5.88898 21.997C1.98898 21.997 2.00098 21.021 2.00098 18.109Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2212 18.109C14.2212 15.193 14.2522 14.221 18.1092 14.221C21.9662 14.221 21.9972 15.193 21.9972 18.109C21.9972 21.025 22.0092 21.997 18.1092 21.997C14.2092 21.997 14.2212 21.021 14.2212 18.109Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16528_1192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame5);
export default __webpack_public_path__ + "static/media/Frame (5).c92e80dd.svg";
export { ForwardRef as ReactComponent };